import React from 'react';
import s from './s.module.less';
import klarityLogo from 'assets/logo/klarity.png';

type Props = {
    height?: number;
};

const KlarityHeader: React.FC<Props> = ({ height = 86 }) => {
    return (
        <div className={s.wrap}>
            <div className={s.wrapIn} style={height ? { height: `${height}px` } : undefined}>
                <img src={klarityLogo} className={s.logo} />
            </div>
        </div>
    );
};

export default KlarityHeader;
